import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createRole, ICreateRoleRequest } from 'src/api/createRole';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { IRole } from 'src/types';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

export const useCreateRole = (onMutationSuccess: () => void) => {
  const { showSnackbar } = useSnackbar();
  const { trackEvent, captureException } = useUserTracking();
  const queryClient = useQueryClient();

  return useMutation((role: ICreateRoleRequest) => createRole(role), {
    onSuccess: (data: IRole) => {
      trackEvent('role_created', {
        permission_count: data.permissions?.length || 0,
      });
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: (
          <>
            <strong>{data.name}</strong> has successfully been created.
          </>
        ),
      });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ROLES] });
      onMutationSuccess();
    },
    onError: (error: Error, req) => {
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: (
          <>
            Unable to create <strong>{req.name}</strong>
          </>
        ),
      });

      captureException(error);
    },
  });
};
